import { _getCurrentRunLoop, run as run$1 } from '../../../@ember/runloop/index.js';

function run(fn) {
  if (!_getCurrentRunLoop()) {
    return run$1(fn);
  } else {
    return fn();
  }
}

export { run as default };
